import { render, staticRenderFns } from "./usuario-detalhe.vue?vue&type=template&id=1434bfee&"
import script from "./usuario-detalhe.vue?vue&type=script&lang=js&"
export * from "./usuario-detalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports